module.exports = __webpack_public_path__ + "img/laos.445a9170.svg";